import * as Vibrant from 'node-vibrant'

export const defaultVibrantColor = "steelblue";

const getColorFromPalette = (palette) => {
  // Some error occurred, return default value
  if ( typeof palette === "undefined" ) return defaultVibrantColor;

  // Extract vibrant color progressively
  if ( palette.LightVibrant !== null ) return palette.LightVibrant.getHex();
  else if ( palette.DarkVibrant !== null ) return palette.DarkVibrant.getHex();
  else if ( palette.Vibrant !== null ) return palette.Vibrant.getHex();
  else if ( palette.Muted !== null ) return palette.Muted.getHex();

  // Nothing worked, return default color too
  return defaultVibrantColor;
}

export const getColorFromImage = (image) => {
  return Vibrant
    .from(image)
    .getPalette()
    .then(getColorFromPalette);
}
